module.exports = __webpack_public_path__ + "img/builder-21.c9b0f4d3.jpg";